<template>
  <full-size-page>
    <a-flex vertical gap="large" align="stretch">
      <a-flex vertical gap="middle">
        <a-typography-title :level="3">Шаблоны этикеток</a-typography-title>

        <router-link
          v-if="labelTemplateStore.isAdminAccount"
          :to="{
            name: 'labelsEdit',
            params: { labelId: 'create' },
            query: { isCommon: 'true' },
          }"
          style="width: fit-content"
        >
          <a-button type="primary">Создать шаблон этикетки</a-button>
        </router-link>

        <CommonLabelTemplateTable />
      </a-flex>

      <a-flex vertical gap="middle">
        <a-typography-title :level="3">Ваши этикетки</a-typography-title>

        <router-link
          :to="{ name: 'labelsEdit', params: { labelId: 'create' } }"
          style="width: fit-content"
        >
          <a-button type="primary">Создать этикетку</a-button>
        </router-link>

        <PersonalLabelTemplateTable />

        <LabelTemplateTableQz />
      </a-flex>
    </a-flex>
  </full-size-page>
</template>

<script setup lang="ts">
import LabelTemplateTableQz from "@/components/settings/labels/labelTemplateTable/LabelTemplateTableQz.vue";
import FullSizePage from "@/components/base/FullSizePage.vue";
import PersonalLabelTemplateTable from "@/components/settings/labels/labelTemplateTable/PersonalLabelTemplateTable.vue";
import CommonLabelTemplateTable from "@/components/settings/labels/labelTemplateTable/CommonLabelTemplateTable.vue";
import { useLabelTemplateStore } from "@/stores/labelTemplate/labelTemplateStore";
const labelTemplateStore = useLabelTemplateStore();
</script>

<style scoped lang="scss"></style>
